export type GenericLiabilityPoint = {
    time: number;
    value: number;
};

export const genericLiability: GenericLiabilityPoint[] = [
    { time: 1, value: 153005464.5 },
    { time: 2, value: 153005464.5 },
    { time: 3, value: 153005464.5 },
    { time: 4, value: 153005464.5 },
    { time: 5, value: 153005464.5 },
    { time: 6, value: 191256830.6 },
    { time: 7, value: 191256830.6 },
    { time: 8, value: 191256830.6 },
    { time: 9, value: 191256830.6 },
    { time: 10, value: 191256830.6 },
    { time: 11, value: 284153005.5 },
    { time: 12, value: 284153005.5 },
    { time: 13, value: 284153005.5 },
    { time: 14, value: 284153005.5 },
    { time: 15, value: 284153005.5 },
    { time: 16, value: 333333333.3 },
    { time: 17, value: 333333333.3 },
    { time: 18, value: 333333333.3 },
    { time: 19, value: 333333333.3 },
    { time: 20, value: 333333333.3 },
    { time: 21, value: 306010929 },
    { time: 22, value: 306010929 },
    { time: 23, value: 306010929 },
    { time: 24, value: 306010929 },
    { time: 25, value: 306010929 },
    { time: 26, value: 262295082 },
    { time: 27, value: 262295082 },
    { time: 28, value: 262295082 },
    { time: 29, value: 262295082 },
    { time: 30, value: 262295082 },
    { time: 31, value: 185792349.7 },
    { time: 32, value: 185792349.7 },
    { time: 33, value: 185792349.7 },
    { time: 34, value: 185792349.7 },
    { time: 35, value: 185792349.7 },
    { time: 36, value: 131147541 },
    { time: 37, value: 131147541 },
    { time: 38, value: 131147541 },
    { time: 39, value: 131147541 },
    { time: 40, value: 131147541 },
    { time: 41, value: 76502732.24 },
    { time: 42, value: 76502732.24 },
    { time: 43, value: 76502732.24 },
    { time: 44, value: 76502732.24 },
    { time: 45, value: 76502732.24 },
    { time: 46, value: 76502732.24 },
    { time: 47, value: 76502732.24 },
    { time: 48, value: 76502732.24 },
    { time: 49, value: 76502732.24 },
    { time: 50, value: 76502732.24 }
];
